(() => {
  if (customElements.get('edvi-announcement')) return;
  class EdviAnnouncement extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.slides = [...this.querySelectorAll('[data-ann-slide]')];
      this.items = this.querySelector('[data-ann-items]');
      this.mobile = matchMedia('(max-width: 1199px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      this.focused = false;
      this.querySelector('[data-ann-prev]').addEventListener('click', () => this.move(-1), options);
      this.querySelector('[data-ann-next]').addEventListener('click', () => this.move(1), options);
      this.addEventListener('pointerdown', e => { this.start = { x: e.clientX, y: e.clientY }; this.sync(); }, options);
      this.addEventListener('pointerup', e => {
        if (!this.start) return;
        const x = e.clientX - this.start.x;
        const y = e.clientY - this.start.y;
        if (Math.abs(x) > 35 && Math.abs(x) > Math.abs(y)) { this.move(x < 0 ? 1 : -1); this.swiped = true; }
        this.start = null;
        this.sync();
      }, options);
      this.addEventListener('pointercancel', () => { this.start = null; this.sync(); }, options);
      this.addEventListener('click', e => { if (this.swiped) { e.preventDefault(); this.swiped = false; } }, { ...options, capture: true });
      this.addEventListener('focusin', () => { this.focused = true; this.sync(); }, options);
      this.addEventListener('focusout', e => { this.focused = this.contains(e.relatedTarget); this.sync(); }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); }, options);
      this.mobile.addEventListener('change', () => this.sync(), options);
      this.reduced.addEventListener('change', () => this.sync(), options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.sync();
    }
    disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); }
    move(step) {
      this.index = (this.index + step + this.slides.length) % this.slides.length;
      this.sync();
    }
    sync() {
      clearInterval(this.timer);
      this.slides.forEach((slide, i) => {
        const hidden = this.mobile.matches && i !== this.index;
        slide.classList.toggle('is-selected', i === this.index);
        slide.inert = hidden;
        slide.setAttribute('aria-hidden', String(hidden));
      });
      const interacting = this.focused || Boolean(this.start);
      this.items.setAttribute('aria-live', interacting ? 'polite' : 'off');
      const stopped = interacting || this.reduced.matches;
      if (this.mobile.matches && !stopped && !this.hovered && !document.hidden) {
        this.timer = setInterval(() => this.move(1), 5000);
      }
    }
  }
  customElements.define('edvi-announcement', EdviAnnouncement);
})();
